import { styled, Table } from '@clickcease/cc-client-components-lib'

export const addDomainModalStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  height: 660,
  maxHeight: '96vh',
}

export const addDomainModalContentStyle = {
  height: 'calc(100% - 113px)',
  boxSizing: 'border-box',
}

export const MultiDomainsTableContainer = styled('div', {
  height: '100%',
  overflowY: 'auto',
})

export const MultiDomainsTable = styled(Table, {
  tableLayout: 'fixed',
  width: '100%',

  thead: {
    height: 34,
    verticalAlign: 'baseline',
    th: {
      paddingLeft: 0,
      '&:nth-child(1)': {
        width: 50,
      },
      '&:nth-child(3)': {
        width: 272,
      },
    },
  },
  tbody: {
    tr: {
      borderBottom: '0.5px solid $gradient',
      padding: '$8 0',
    },
    'td, td:last-of-type': {
      height: 54,
      borderBottom: 'unset',

      '&:not(:first-of-type)': {
        paddingLeft: 0,
      },
    },
  },
})

export const MultiDomainsContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: 660,
  height: '100%',
  maxWidth: '90vw',
  boxSizing: 'border-box',
})

export const AddDomainsWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',

  '> button': {
    margin: '$8 0 $8 auto',
  },
})

export const AddDomainsTopLIne = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '$5',
  height: 30,
})

export const TableCell = styled('td', {})

export const AddressCell = styled(TableCell, {
  width: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  paddingRight: '$4',
  paddingLeft: 0,
})

export const ProductSelectCell = styled(TableCell, {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'start',
})
